module.exports = __webpack_public_path__ + "static/media/lower.fdd89038.ogg";